"use client";

import React from "react";
import { Star, ShieldCheck, ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ReviewsHero() {
  const shouldReduceMotion = useReducedMotion();
  const trustPoints = [{
    text: "NASC & CHAS accredited"
  }, {
    text: "20+ years of scaffolding leadership"
  }, {
    text: "Covering London & the South East"
  }];
  return <section id="reviewshero" data-nav="light" className="relative overflow-hidden bg-background py-16 md:py-24 lg:py-28 border-b border-border">
      {/* Subtle background decor */}
      <div className="absolute inset-0 pointer-events-none -z-10 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-accent/60 via-background to-background" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="text-center flex flex-col items-center">
          {/* Rating Pill Badge */}
          <div className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-4 py-1.5 shadow-xs mb-6">
            <div className="flex items-center gap-1 text-chart-5">
              <Star className="size-4 fill-chart-5 text-chart-5" />
              <Star className="size-4 fill-chart-5 text-chart-5" />
              <Star className="size-4 fill-chart-5 text-chart-5" />
              <Star className="size-4 fill-chart-5 text-chart-5" />
              <Star className="size-4 fill-chart-5 text-chart-5" />
            </div>
            <span className="text-xs font-semibold text-foreground tracking-wide uppercase">
              5.0 Star Verified Rating
            </span>
          </div>

          {/* Main Title */}
          <h1 className="font-default text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-foreground max-w-3xl">
            Rated 5 stars on Google
          </h1>

          {/* Supporting Description */}
          <p className="mt-6 text-lg sm:text-xl text-muted-foreground max-w-2xl leading-relaxed">
            BMF Scaffolding Ltd is trusted by homeowners, roofing contractors, and commercial clients across Berkshire, Surrey, Hampshire, Buckinghamshire, London and the Home Counties for safety-led, professional scaffolding.
          </p>

          {/* Call to Actions */}
          <div className="mt-8 flex items-center justify-center w-full sm:w-auto">
            <Button asChild size="lg" className="w-full sm:w-auto font-medium shadow-md transition-[background-color,box-shadow]">
              <Link to="/ContactRequestQuotePage">
                <span>Request a Quote</span>
                <ArrowRight className="size-4 ml-1.5" />
              </Link>
            </Button>
          </div>

          {/* Key Accreditation & Trust Badges Strip */}
          <div className="mt-12 pt-8 border-t border-border/80 w-full max-w-3xl">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center sm:text-left">
              {trustPoints.map((point, i) => <div key={i} data-index={i} className="flex items-center justify-center sm:justify-start gap-2.5 text-xs sm:text-sm font-medium text-muted-foreground">
                  <ShieldCheck className="size-4 shrink-0 text-primary" />
                  <span>{point.text}</span>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}